/*
 * core-bloggy.js — replace the Bloggy app's standalone CTA links with the theme's
 * ornamental button.
 *
 * The Bloggy app renders the article body as #bloggy--article. Its standalone CTAs
 * are <a class="bggle_button-link"> inside a .bggle_button block. Each is swapped for
 * a clone of the ornamental-button <template> that theme.liquid renders on article
 * pages, carrying over the CTA's href, visible label, and (external) target. The
 * product-carousel links (.bggle--slider .bggle_button-link) are intentionally NOT
 * matched — they stay as Bloggy's product buttons.
 *
 * Loaded only on the article template (layout/theme.liquid). Hand-authored asset
 * (no build step), mirroring the theme's other hand-authored assets.
 */
(function () {
  var TEMPLATE_ID = 'BloggyOrnamentalCta';
  // Standalone CTAs only: a .bggle_button-link INSIDE a .bggle_button block.
  var CTA_SELECTOR = '#bloggy--article .bggle_button .bggle_button-link';
  // Bloggy sometimes emits an <h1> in the article body — a duplicate of the page's real
  // <h1> (the article title, rendered by a custom section above). Demote these to <h2>.
  var DEMOTE_SELECTOR = '#bloggy--article h1';
  // Bloggy's product carousel leaves the <img> with an empty src (its client hydration
  // fills title/price but not the image on these articles). We fill it from the product.
  var PRODUCT_SELECTOR = '#bloggy--article .bggle_product-container';
  var observer = null;

  function swap(link) {
    var tmpl = document.getElementById(TEMPLATE_ID);
    var proto = tmpl && tmpl.content && tmpl.content.firstElementChild;
    if (!proto) return;

    var button = proto.cloneNode(true);
    var href = link.getAttribute('href');
    if (href) button.setAttribute('href', href);

    if (link.getAttribute('target') === '_blank') {
      button.setAttribute('target', '_blank');
      button.setAttribute('rel', 'noopener noreferrer');
    }

    var label = button.querySelector('.core-ornamental-button__label');
    if (label) label.textContent = (link.textContent || '').trim();

    link.replaceWith(button);
  }

  // Convert a Bloggy <h1> to an <h2> (preserving attributes + children) so the page keeps a
  // single <h1> (the title). The `.core-bloggy-demoted-h1` marker lets core-bloggy.css keep
  // the h3 look on this heading even though it is now an <h2>.
  function demoteHeading(h1) {
    var h2 = document.createElement('h2');
    for (var i = 0; i < h1.attributes.length; i++) {
      h2.setAttribute(h1.attributes[i].name, h1.attributes[i].value);
    }
    h2.classList.add('core-bloggy-demoted-h1');
    while (h1.firstChild) h2.appendChild(h1.firstChild);
    h1.replaceWith(h2);
  }

  // Fill a Bloggy product card's empty <img> from the product handle on its container.
  // Bloggy hydrates the title/price client-side but leaves the image blank; we fetch the
  // product JSON (/products/<handle>.js) and set the featured image. Guarded so it runs
  // once per card and never overwrites a src Bloggy may have set.
  function fillProductImage(container) {
    if (container.dataset.bloggyImg) return;
    var img = container.querySelector('.bloggle_product--img');
    if (!img || img.getAttribute('src')) return;
    var handle = container.getAttribute('bggle-product-handle');
    if (!handle) return;
    container.dataset.bloggyImg = '1';
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.featured_image || img.getAttribute('src')) return;
        var url = p.featured_image;
        if (url.indexOf('//') === 0) url = 'https:' + url;
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=600';
        img.src = url;
        if (!img.getAttribute('alt')) img.alt = p.title || '';
      })
      .catch(function () {});
  }

  function reconnect() {
    var root = document.getElementById('bloggy--article') || document.body;
    observer.observe(root, { childList: true, subtree: true });
  }

  function enhance() {
    // Detach while we mutate so our own replacements don't re-trigger the observer.
    if (observer) observer.disconnect();
    document.querySelectorAll(DEMOTE_SELECTOR).forEach(demoteHeading);
    document.querySelectorAll(CTA_SELECTOR).forEach(swap);
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(fillProductImage);
    if (observer) reconnect();
  }

  function init() {
    // Re-run if Bloggy injects / re-renders its content after initial load.
    observer = new MutationObserver(enhance);
    enhance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
